class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
  }

  connectedCallback() {
    this.contentElement = this.querySelector('[data-read-more-content]');
    this.toggleButton = this.querySelector('[data-content-toggle]');
    this.readMoreLabel = this.getAttribute('data-read-more-label') || 'Read more';
    this.readLessLabel = this.getAttribute('data-read-less-label') || 'Read less';

    if (this.toggleButton && this.contentElement) {
      // Set initial state
      this.updateButtonText();
      
      // Add click event listener
      this.toggleButton.addEventListener('click', () => {
        this.toggle();
      });
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    
    if (this.contentElement) {
      if (this.isExpanded) {
        // Show content with fade-in
        this.contentElement.style.display = 'block';
        // Trigger fade-in animation
        requestAnimationFrame(() => {
          this.contentElement.classList.add('is-visible');
        });
      } else {
        // Hide content with fade-out
        this.contentElement.classList.remove('is-visible');
        // Wait for transition to complete before hiding
        setTimeout(() => {
          if (!this.isExpanded) {
            this.contentElement.style.display = 'none';
          }
        }, 300);
      }
    }
    
    this.updateButtonText();
  }

  updateButtonText() {
    if (this.toggleButton) {
      this.toggleButton.textContent = this.isExpanded ? this.readLessLabel : this.readMoreLabel;
    }
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}